const profile = {
    name: 'Nome',
    avatar: 'Avatar',
    givenName: 'Nome',
    familyName: 'Cognome',
    middleName: 'Secondo nome',
    fullname: 'Nome completo',
    nickname: 'Soprannome',
    preferredUsername: 'Nome utente preferito',
    profile: 'Profilo',
    website: 'Sito web',
    gender: 'Genere',
    birthdate: 'Data di nascita',
    zoneinfo: 'Fuso orario',
    locale: 'Lingua',
    address: {
        formatted: 'Indirizzo',
        streetAddress: 'Indirizzo',
        locality: 'Città',
        region: 'Stato/Provincia',
        postalCode: 'CAP',
        country: 'Paese',
    },
    gender_options: {
        female: 'Femmina',
        male: 'Maschio',
        prefer_not_to_say: 'Preferisco non dire',
    },
    checkbox_value: {
        checked: 'Sì',
        unchecked: 'No',
    },
    avatar_upload: {
        upload: 'Carica',
        remove: 'Rimuovi',
        uploading: 'Caricamento...',
        hint: 'Dimensione consigliata 1:1, fino a {{limit}}.',
        error_file_type: 'Il tipo di file deve essere {{extensions}}.',
        error_file_size: 'La dimensione del file non deve superare {{limit}}.',
        error_storage_not_configured: 'Impossibile caricare la foto. Riprova più tardi.',
        error_upload: 'Impossibile caricare la foto. Riprova.',
        error_save: 'Impossibile salvare la tua foto. Riprova.',
        crop_title: 'Ritaglia foto',
        zoom: 'Zoom',
        error_crop: "Impossibile ritagliare l'immagine. Riprova.",
    },
};
export default Object.freeze(profile);
